import React, { useState } from 'react';
import { useToast } from '../../../../hooks/useToast';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ActionMenu, {Action} from '../../../../components/ui/materialui/actionMenu';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import inmobiliariaDto from '../models/inmobiliariaDto';
import { softDeleteInmobiliaria } from '../service/servicesInmobiliarias';
import { AxiosResponse } from 'axios';
import { StatusCode, TipoFuncionalidad } from '../../../../utils/enums'; 
import { InmobiliariaWriteDto } from './inmobiliariaForm';
import { usePermissions } from '../../../../components/auth/ProtectedRoute';
import { getCurrentUsername } from '../../../../services/userRolesService';

interface IProps {
  inmobiliaria: inmobiliariaDto;
  setInmobiliariaEditar: React.Dispatch<React.SetStateAction<InmobiliariaWriteDto | undefined>>;
  setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
  renderizar: () => void;
}

const AccionesInmobiliaria: React.FC<IProps> = ({ inmobiliaria, renderizar, setInmobiliariaEditar, setModalDetalle }) => {
  const { hasPermission } = usePermissions();
  const puedeEditar = hasPermission(TipoFuncionalidad.Maestros_editar);

  const [modalConfirmacion, setModalConfirmacion] = useState({
    show: false,
    title: '',
    message: '',
    metodo: () => {},
  })

  const { addToast } = useToast();

  async function EliminarInmobiliaria(inmobiliaria: inmobiliariaDto) {
    const response: AxiosResponse = await softDeleteInmobiliaria(inmobiliaria.id);

    if (response.status === StatusCode.NoContent) {
      setModalConfirmacion({ ...modalConfirmacion, show: false })
      renderizar();
      addToast({
        mostrar: true,
        titulo: 'Confirmación',
        tipo: 'Success',
        mensaje: 'Inmobiliaria eliminada correctamente'
      });
    } else {
      setModalConfirmacion({ ...modalConfirmacion, show: false })
    }
  }

  const handleEditarClick = () => {
    setInmobiliariaEditar({
      id: inmobiliaria.id,
      rut: inmobiliaria.rut,
      nombre: inmobiliaria.nombre,
      rutHolding: inmobiliaria.rutHolding,
      nombreHolding: inmobiliaria.nombreHolding,
      convenioId: inmobiliaria.convenioId,
      nombreUsuario: getCurrentUsername()
    })
    setModalDetalle(true)
  }

  const handleEliminarClick = () => {
    setModalConfirmacion({
      show: true,
      title: "Eliminar Inmobiliaria",
      message: inmobiliaria.nombre,
      metodo: () => {
        EliminarInmobiliaria(inmobiliaria)
      },
    })
  }

 const actions: Action[] = [];

if (puedeEditar) {
  actions.push({
    label: "Editar",
    icon: <EditIcon fontSize="small" />,
    onClick: handleEditarClick
  });

  actions.push({
    label: "Eliminar",
    icon: <DeleteIcon fontSize="small" />,
    onClick: handleEliminarClick
  });
}


return (
  <>
    {actions.length > 0 && <ActionMenu actions={actions} />}

    <ConfirmationModal
      onHide={() => setModalConfirmacion({ ...modalConfirmacion, show: false })}
      onConfirm={modalConfirmacion.metodo}
      show={modalConfirmacion.show}
      title={modalConfirmacion.title}
      message={modalConfirmacion.message}
    />
  </>
);
};

export default AccionesInmobiliaria;